"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpProvider = void 0;
const HttpService_1 = require("./HttpService");
exports.httpProvider = HttpService_1.HttpService.getInstance();
//# sourceMappingURL=HttpProvider.js.map